import React, { ReactElement } from 'react';
import Text from './ui/text';
import { VscChevronRight } from 'react-icons/vsc';
import { IoMdReturnRight } from 'react-icons/io';
import IndexText from './index-text';
import { CMSLink } from '../v2/components/CMSLink';

interface Props {
  href?: string;
  link?: any;
  onClick?: () => void;
  order: string;
}

export default function SolutionLinkItem({
  link,
  order,
  onClick,
}: Props): ReactElement {
  return (
    <div
      onClick={onClick}
      className="group z-20 relative col-span-4 bg-white bg-opacity-0 border-opacity-50 hover:border-opacity-100 py-8 md:py-10 lg:py-20 flex flex-col justify-center items-start border-t hover:border-telesoft border-white transition-colors duration-300"
    >
      <CMSLink {...link}>
        <IndexText index={order} className="absolute top-1 left-0" />
        <div className="flex justify-between items-center w-full">
          <div className="flex justify-start items-start">
            <IoMdReturnRight className="text-white opacity-50 group-hover:opacity-100 mr-3 mt-1 text-xl transition-opacity duration-300" />
            <Text
              variant="headingLight"
              className="max-w-xs text-left group-hover:underline"
            >
              {link.label}
            </Text>
          </div>
          <VscChevronRight className="text-white mr-2 text-xl opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:translate-x-2" />
        </div>
      </CMSLink>
    </div>
  );
}
